define.alias("ember-math-helpers/helpers/gcd", "media/helpers/gcd");